// This is function is being used to get the hostname from the URL by removing the protocol and path
export const getDomain = (url: string) => {
  try {
    const { hostname } = new URL(url);
    return hostname;
  } catch {
    return '';
  }
};
